import React from 'react';
import { CopyOutlined } from '@aelf-design/icons';
import { message } from 'antd';
import copy from 'copy-to-clipboard';
export default function Copy(_ref) {
  var value = _ref.value,
    className = _ref.className;
  var handleCopy = function handleCopy(e) {
    e.preventDefault();
    e.stopPropagation();
    try {
      copy(value);
      message.success('Copied Successfully');
    } catch (e) {
      message.error('Copy failed, please copy by yourself.');
    }
  };
  return /*#__PURE__*/React.createElement(CopyOutlined, {
    className: className,
    onClick: handleCopy
  });
}